:host {
  /* if a new variable is added here, it should also be reflected in genericOverlay.scss and therefore
  in GzGenericOverlayWebComponent:ts:getGenericOverlayElementStyles()
   */
  --overlay-width: fit-content;
  --overlay-height: fit-content;
  --overlay-max-width: 100%;
  --overlay-max-height: 100%;
  --overlay-min-width: none;
  --overlay-min-height: none;
  --overlay-border: 1px solid var(--blue-layout-301-active);
  --overlay-border-radius: calc(var(--spacer) / 2);
  --overlay-box-shadow: none;
  --overlay-background: var(--white-layout-301-level-0-elevation);
  --overlay-content-color: var(--main-titles-inputs-600);
}
